import * as React from 'react';
import type { UpdateBlockedProductPayload } from 'contracts/blocked-products';
import { api } from 'services/api';

type Params = {
  productId: number;
  payload: UpdateBlockedProductPayload;
}

export const useUpdateBlockedProduct = () => {
  const updateProduct = React.useCallback(async (params: Params) => {
    const url = `/inventory/blocked-products/${params.productId}`;
    await api.put(url, params.payload);
  }, []);

  return {
    updateProduct,
  };
};